import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";


GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.14.305/build/pdf.worker.min.js";


export async function pdfPageToImage(url: string, page: number): Promise<Blob> {
  const pdfDocument = await getDocument(url).promise;
  const pageContent = await pdfDocument.getPage(page);

  const viewport = pageContent.getViewport({
    scale: 1
  });

  const canvas = document.createElement("canvas");
  const context = canvas.getContext('2d');

  canvas.height = viewport.height;
  canvas.width = viewport.width;

  // Render PDF page into canvas context
  const renderContext = {
    canvasContext: context,
    viewport: viewport
  };

  await pageContent.render(renderContext).promise;

  return new Promise<Blob>((resolve) => {
    canvas.toBlob((blob: Blob) => {
      resolve(blob);
    });
  });
}
